import { welfareDetailsApi } from 'app/src/services/welfareportal'
import { ListItemRenderer } from 'app/src/shared/components'
import { HorizontalCard } from 'app/src/shared/components/HorizontalCard'
import { useWebAppContext } from 'app/src/shared/hooks'

export function WelfareDetailsSection() {
  const context = useWebAppContext()

  const welfareDetails = welfareDetailsApi.useWelfareDetailsRequestList({
    pathParams: { templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })

  return (
    <div className='mx-auto'>
      <div className='grid grid-cols-12'>
        <h2 className='col-span-11 col-start-1 text-[32px] font-bold leading-[32px] text-[#4A4A4A] md:col-span-11 md:col-start-1'>
          {welfareDetails?.data?.title}
        </h2>
        <p className='col-span-11 col-start-1 my-[25px] text-[16px] font-normal leading-[24px] text-[#4A4A4A] md:col-span-11 md:col-start-1'>
          {welfareDetails?.data?.description}
        </p>
      </div>
      <ListItemRenderer
        data={{ items: welfareDetails?.data?.cards }}
        pt={{
          container: {
            className: 'grid grid-cols-1 gap-10 lg:grid-cols-2',
          },
          autofocus: {
            disabled: true,
          },
        }}
        renderItem={(card) => (
          <HorizontalCard key={card.id} title={card.title} description={card.body} imageSrc={card.imageSrc} />
        )}
      />
    </div>
  )
}
